import { UnauthorizedMessage } from '#modules/error';
import { PageContent } from '#modules/page';

export default function UnauthorizedScene() {
  return (
    <PageContent empty={true}>
      <UnauthorizedMessage />
    </PageContent>
  );
}
